export default __webpack_public_path__ + "static/CopernicusWeb-Bold-e96a5211ce0ae083ff20839f5230ef06.woff2";